import { render, staticRenderFns } from "./AddDepartment.vue?vue&type=template&id=0da523b6&scoped=true"
import script from "./AddDepartment.vue?vue&type=script&lang=js"
export * from "./AddDepartment.vue?vue&type=script&lang=js"
import style0 from "./AddDepartment.vue?vue&type=style&index=0&id=0da523b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da523b6",
  null
  
)

export default component.exports